module.exports = __webpack_public_path__ + "static/dumpster-b3ec961a07048da646a456150df1e35c.jpg";